(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94b4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94b4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fw0Zn", function(module, exports) {

$parcel$export(module.exports, "get_info", function () { return $b4ba9c8e7a201193$export$3697bcf53517e83c; });

var $e96f1 = parcelRequire("e96f1");

var $h9BHh = parcelRequire("h9BHh");

var $5eYZm = parcelRequire("5eYZm");
async function $b4ba9c8e7a201193$export$3697bcf53517e83c() {
    let response = await (0, $h9BHh.get_info_cached)();
    if (typeof response !== 'object') {
        console.error('Geolocation IP Detection Error: Record should be an object, not a ' + typeof response, response);
        response = {
            'extra': {
                'error': response || 'Network error, look at the original server response ...'
            }
        };
    }
    const record = new (0, $e96f1.default)(response, (0, $5eYZm.options).default_locales);
    return record;
}

});
parcelRegister("e96f1", function(module, exports) {

$parcel$export(module.exports, "camelToUnderscore", function () { return $a4c6bf567c1b63c8$export$13bc6c4afe8cd6ab; });
$parcel$export(module.exports, "default", function () { return $a4c6bf567c1b63c8$export$2e2bcd8739ae039; });

var $8WYat = parcelRequire("8WYat");

var $aUbCw = parcelRequire("aUbCw");
const $a4c6bf567c1b63c8$var$_get_localized = function(ret, locales) {
    if (typeof ret === 'object' && ret !== null) {
        if (typeof ret.names === 'object' && typeof locales === 'object') for(let i = 0; i < locales.length; i++){
            let locale = locales[i];
            if (ret.names[locale]) return ret.names[locale];
        }
        if (ret.name) return ret.name;
        return '';
    }
    return ret;
};
const $a4c6bf567c1b63c8$export$13bc6c4afe8cd6ab = function(key) {
    key = key.split('.').map((x)=>{
        if (typeof x !== 'string' || typeof x[0] !== 'string') return '';
        x = x[0].toLowerCase() + x.slice(1); // to allow "MostSpecificSubdivision"
        x = x.replace(/([A-Z])/g, "_$1").toLowerCase();
        return x;
    }).join('.');
    return key;
};
class $a4c6bf567c1b63c8$var$Record {
    get(prop, default_value) {
        return this.get_with_locales(prop, null, default_value);
    }
    get_raw(prop) {
        prop = $a4c6bf567c1b63c8$export$13bc6c4afe8cd6ab(prop);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aUbCw)))(this.data, prop, null);
    }
    has_property(prop) {
        const ret = this._lookup_with_locales(prop, this.default_locales, null);
        return ret !== null;
    }
    _lookup_with_locales(prop, locales, default_value = '') {
        locales = this._process_locales(locales);
        // Treat pseudo-property 'name' as if it never existed
        if (prop.substr(-5) === '.name') prop = prop.substr(0, prop.length - 5);
        let ret = this.get_raw(prop);
        // Localize property, if possible
        ret = $a4c6bf567c1b63c8$var$_get_localized(ret, locales);
        if (ret === null || ret === '') ret = default_value;
        return ret;
    }
    _process_locales(locales) {
        if (typeof locales === 'string') locales = [
            locales
        ];
        if (!Array.isArray(locales) || locales.length === 0) locales = this.default_locales;
        return locales;
    }
    get_with_locales(prop, locales, default_value) {
        const ret = this._lookup_with_locales(prop, locales, default_value);
        if (typeof ret === 'object') console.warn('Geolocation IP Detection: The property "' + prop + '" is of type "' + typeof ret + '", should be string or similar', ret);
        if (typeof ret === 'undefined') {
            console.warn('Geolocation IP Detection: The property "' + prop + '" is not defined, please check spelling or maybe you need a different data source', {
                data: this.data
            });
            return '';
        }
        return ret;
    }
    get_country_iso() {
        let country = this.get('country.iso_code');
        if (country) country = country.substr(0, 2).toLowerCase();
        return country;
    }
    /**
     * Check if there is information available for this IP
     * @returns boolean 
     */ is_empty() {
        return this.get('is_empty', false);
    }
    /**
     * Get error message, if any
     * @return string Error Message
     */ error() {
        return this.get_raw('extra.error') || '';
    }
    /**
     * Get the raw data of this object
     * @returns object
     */ serialize() {
        return this.data;
    }
    constructor(data, default_locales){
        (0, $8WYat._)(this, "data", {});
        (0, $8WYat._)(this, "default_locales", []);
        this.data = data || {
            is_empty: true
        };
        this.default_locales = [
            'en'
        ];
        this.default_locales = this._process_locales(default_locales);
    }
}
var $a4c6bf567c1b63c8$export$2e2bcd8739ae039 = $a4c6bf567c1b63c8$var$Record;

});
parcelRegister("8WYat", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $68426998e3b11619$export$1e71eb4bef00f6b0; });
function $68426998e3b11619$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("aUbCw", function(module, exports) {
module.exports = $72e224a45f2258bd$var$get;
/*
  const obj = {a: {aa: {aaa: 2}}, b: 4};

  get(obj, 'a.aa.aaa'); // 2
  get(obj, ['a', 'aa', 'aaa']); // 2

  get(obj, 'b.bb.bbb'); // undefined
  get(obj, ['b', 'bb', 'bbb']); // undefined

  get(obj.a, 'aa.aaa'); // 2
  get(obj.a, ['aa', 'aaa']); // 2

  get(obj.b, 'bb.bbb'); // undefined
  get(obj.b, ['bb', 'bbb']); // undefined

  get(obj.b, 'bb.bbb', 42); // 42
  get(obj.b, ['bb', 'bbb'], 42); // 42

  get(null, 'a'); // undefined
  get(undefined, ['a']); // undefined

  get(null, 'a', 42); // 42
  get(undefined, ['a'], 42); // 42

  const obj = {a: {}};
  const sym = Symbol();
  obj.a[sym] = 4;
  get(obj.a, sym); // 4
*/ function $72e224a45f2258bd$var$get(obj, propsArg, defaultValue) {
    if (!obj) return defaultValue;
    var props, prop;
    if (Array.isArray(propsArg)) props = propsArg.slice(0);
    if (typeof propsArg == 'string') props = propsArg.split('.');
    if (typeof propsArg == 'symbol') props = [
        propsArg
    ];
    if (!Array.isArray(props)) throw new Error('props arg must be an array, a string or a symbol');
    while(props.length){
        prop = props.shift();
        if (!obj) return defaultValue;
        obj = obj[prop];
        if (obj === undefined) return defaultValue;
    }
    return obj;
}

});


parcelRegister("h9BHh", function(module, exports) {

$parcel$export(module.exports, "get_info_cached", function () { return $c7d084c9c1bb0fef$export$fba94e0366f5a647; });

var $6XCbI = parcelRequire("6XCbI");

var $5eYZm = parcelRequire("5eYZm");

var $kXwF1 = parcelRequire("kXwF1");
let $c7d084c9c1bb0fef$var$ajaxPromise = null;
function $c7d084c9c1bb0fef$var$get_info_raw() {
    if (!$c7d084c9c1bb0fef$var$ajaxPromise) {
        // Do Ajax Request only once per page load
        const url = (0, $5eYZm.options).ajaxurl + '?action=geoip_detect2_get_info_from_current_ip';
        $c7d084c9c1bb0fef$var$ajaxPromise = (0, $6XCbI.makeJSONRequest)(url);
        $c7d084c9c1bb0fef$var$ajaxPromise.then((response)=>{
            var _response_extra;
            if (response === null || response === void 0 ? void 0 : (_response_extra = response.extra) === null || _response_extra === void 0 ? void 0 : _response_extra.error) console.error('Geolocation IP Detection Error: Server returned an error: ' + response.extra.error);
        });
    }
    return $c7d084c9c1bb0fef$var$ajaxPromise;
}
async function $c7d084c9c1bb0fef$export$fba94e0366f5a647() {
    let response = false;
    let storedResponse = false;
    // 1) Load Info from localstorage cookie cache, if possible
    if ((0, $5eYZm.options).cookie_name) {
        storedResponse = (0, $kXwF1.getRecordDataFromLocalStorage)();
        if (storedResponse === null || storedResponse === void 0 ? void 0 : storedResponse.extra /* this is the only property that is guarantueed */ ) {
            if (storedResponse.extra.override === true) console.info('Geolocation IP Detection: Using cached response (override)');
            else console.info('Geolocation IP Detection: Using cached response');
            return storedResponse;
        }
    }
    // 2) Get response
    try {
        response = await $c7d084c9c1bb0fef$var$get_info_raw();
    } catch (err) {
        console.log('Weird: Uncaught error...', err);
        response = err.responseJSON || err;
    }
    // 3) Save info to localstorage cookie cache
    if ((0, $5eYZm.options).cookie_name) {
        var _storedResponse_extra, _response_extra;
        // Check if Override has been set now
        storedResponse = (0, $kXwF1.getRecordDataFromLocalStorage)();
        if ((storedResponse === null || storedResponse === void 0 ? void 0 : (_storedResponse_extra = storedResponse.extra) === null || _storedResponse_extra === void 0 ? void 0 : _storedResponse_extra.override) === true) {
            console.info('Geolocation IP Detection: Using cached response (override)');
            return storedResponse;
        }
        let cache_duration = (0, $5eYZm.options).cookie_duration_in_days * 86400;
        if (response === null || response === void 0 ? void 0 : (_response_extra = response.extra) === null || _response_extra === void 0 ? void 0 : _response_extra.error) cache_duration = 60; // Cache errors only for 1 minute, then try again
        (0, $kXwF1.setRecordDataToLocalStorage)(response, cache_duration);
    }
    return response;
}

});
parcelRegister("6XCbI", function(module, exports) {

$parcel$export(module.exports, "makeJSONRequest", function () { return $5115e01e50a35b95$export$49434baf33460b11; });
// @see https://gomakethings.com/promise-based-xhr/
const $5115e01e50a35b95$export$699251e5611cc6db = function(url, method = 'GET') {
    // Create the XHR request
    var request = new XMLHttpRequest();
    // Return it as a Promise
    return new Promise(function(resolve, reject) {
        // Setup our listener to process compeleted requests
        request.onreadystatechange = function() {
            // Only run if the request is complete
            if (request.readyState !== 4) return;
            // Process the response
            if (request.status >= 200 && request.status < 300) // If successful
            resolve(request);
            else // If failed
            reject({
                status: request.status,
                statusText: request.statusText,
                request: request
            });
        };
        // Setup our HTTP request
        request.open(method || 'GET', url, true);
        // Send the request
        request.send();
    });
};
const $5115e01e50a35b95$export$8fe2eaa78e58529f = function(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return $5115e01e50a35b95$var$createErrorObject('Invalid JSON: ' + str);
    }
};
function $5115e01e50a35b95$var$createErrorObject(errorMsg) {
    return {
        is_empty: true,
        extra: {
            error: errorMsg
        }
    };
}
const $5115e01e50a35b95$export$49434baf33460b11 = async function(url, method = 'GET') {
    try {
        const request = await $5115e01e50a35b95$export$699251e5611cc6db(url, method);
        if (!request.responseText || request.responseText === '0') return $5115e01e50a35b95$var$createErrorObject('Got an empty response from server. Did you enable AJAX in the options?');
        return $5115e01e50a35b95$export$8fe2eaa78e58529f(request.responseText);
    } catch (e) {
        return $5115e01e50a35b95$export$8fe2eaa78e58529f(e.request.responseText);
    }
};

});

parcelRegister("5eYZm", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $3d0d91a3ea5987c5$export$41c562ebe57d11e2; });
var $3d0d91a3ea5987c5$var$_window_geoip_detect;
const $3d0d91a3ea5987c5$export$41c562ebe57d11e2 = (($3d0d91a3ea5987c5$var$_window_geoip_detect = window.geoip_detect) === null || $3d0d91a3ea5987c5$var$_window_geoip_detect === void 0 ? void 0 : $3d0d91a3ea5987c5$var$_window_geoip_detect.options) || {
    ajaxurl: "/wp-admin/admin-ajax.php",
    default_locales: [
        'en'
    ],
    cookie_duration_in_days: 7,
    cookie_name: 'geoip-detect-result',
    do_body_classes: false
};

});

parcelRegister("kXwF1", function(module, exports) {

$parcel$export(module.exports, "getRecordDataFromLocalStorage", function () { return $f422a70a3b9c8a83$export$c0c5a36406ccde34; });
$parcel$export(module.exports, "setRecordDataToLocalStorage", function () { return $f422a70a3b9c8a83$export$bfae0a1e3adc82ee; });
$parcel$export(module.exports, "getRecordDataLastEvaluated", function () { return $f422a70a3b9c8a83$export$88983ef80f4f72ac; });
$parcel$export(module.exports, "setRecordDataLastEvaluated", function () { return $f422a70a3b9c8a83$export$7bc079f12f70511d; });

var $de3ze = parcelRequire("de3ze");

var $5eYZm = parcelRequire("5eYZm");

var $e96f1 = parcelRequire("e96f1");
const $f422a70a3b9c8a83$export$c0c5a36406ccde34 = ()=>{
    return (0, $de3ze.getLocalStorage)((0, $5eYZm.options).cookie_name);
};
const $f422a70a3b9c8a83$export$bfae0a1e3adc82ee = (data, cache_duration)=>{
    (0, $de3ze.setLocalStorage)((0, $5eYZm.options).cookie_name, data, cache_duration);
};
let $f422a70a3b9c8a83$var$lastEvaluated = {};
const $f422a70a3b9c8a83$export$88983ef80f4f72ac = ()=>{
    return $f422a70a3b9c8a83$var$lastEvaluated;
};
const $f422a70a3b9c8a83$export$7bc079f12f70511d = ()=>{
    $f422a70a3b9c8a83$var$lastEvaluated = $f422a70a3b9c8a83$export$c0c5a36406ccde34();
};
const $f422a70a3b9c8a83$export$5bfd3f24e770e2a9 = ()=>{
    return new (0, $e96f1.default)($f422a70a3b9c8a83$export$c0c5a36406ccde34(), (0, $5eYZm.options).default_locales);
};

});
parcelRegister("de3ze", function(module, exports) {

$parcel$export(module.exports, "setLocalStorage", function () { return $9a0f598d59a61a3e$export$1f73f60bdb811cb1; });
$parcel$export(module.exports, "getLocalStorage", function () { return $9a0f598d59a61a3e$export$d3720feff416e85b; });
const $9a0f598d59a61a3e$export$1f73f60bdb811cb1 = function(variable, value, ttl_sec) {
    var data = {
        value: value,
        expires_at: new Date().getTime() + ttl_sec * 1000 / 1
    };
    localStorage.setItem(variable.toString(), JSON.stringify(data));
};
function $9a0f598d59a61a3e$export$720fb0373088e6ec(variable) {
    localStorage.removeItem(variable);
}
const $9a0f598d59a61a3e$export$d3720feff416e85b = function(variable) {
    let data = null;
    try {
        data = JSON.parse(localStorage.getItem(variable.toString()));
    } catch (e) {
        return null;
    }
    if (data !== null) {
        if (data.expires_at !== null && data.expires_at < new Date().getTime()) localStorage.removeItem(variable.toString());
        else return data.value;
    }
    return null;
};

});




/*
 Variant "Full": 

 All the features, biggest filesize
*/ 
var $fw0Zn = parcelRequire("fw0Zn");

var $de3ze = parcelRequire("de3ze");

var $5eYZm = parcelRequire("5eYZm");

var $e96f1 = parcelRequire("e96f1");
var $8435f80da3db6af7$exports = {};
$8435f80da3db6af7$exports = $8435f80da3db6af7$var$set;
/*
  var obj1 = {};
  set(obj1, 'a.aa.aaa', 4); // true
  obj1; // {a: {aa: {aaa: 4}}}

  var obj2 = {};
  set(obj2, ['a', 'aa', 'aaa'], 4); // true
  obj2; // {a: {aa: {aaa: 4}}}

  var obj3 = {a: {aa: {aaa: 2}}};
  set(obj3, 'a.aa.aaa', 3); // true
  obj3; // {a: {aa: {aaa: 3}}}

  const obj5 = {a: {}};
  const sym = Symbol();
  set(obj5.a, sym, 7); // true
  obj5; // {a: {Symbol(): 7}}
*/ function $8435f80da3db6af7$var$set(obj, propsArg, value) {
    var props, lastProp;
    if (Array.isArray(propsArg)) props = propsArg.slice(0);
    if (typeof propsArg == 'string') props = propsArg.split('.');
    if (typeof propsArg == 'symbol') props = [
        propsArg
    ];
    if (!Array.isArray(props)) throw new Error('props arg must be an array, a string or a symbol');
    lastProp = props.pop();
    if (!lastProp) return false;
    $8435f80da3db6af7$var$prototypeCheck(lastProp);
    var thisProp;
    while(thisProp = props.shift()){
        $8435f80da3db6af7$var$prototypeCheck(thisProp);
        if (typeof obj[thisProp] == 'undefined') obj[thisProp] = {};
        obj = obj[thisProp];
        if (!obj || typeof obj != 'object') return false;
    }
    obj[lastProp] = value;
    return true;
}
function $8435f80da3db6af7$var$prototypeCheck(prop) {
    // coercion is intentional to catch prop values like `['__proto__']`
    if (prop == '__proto__' || prop == 'constructor' || prop == 'prototype') throw new Error('setting of prototype values not supported');
}



var $aUbCw = parcelRequire("aUbCw");
var $d73968d8a0a066f2$export$2e2bcd8739ae039 = $d73968d8a0a066f2$var$compare;
/*
  primitives: value1 === value2
  functions: value1.toString == value2.toString
  arrays: if length, sequence and values of properties are identical
  objects: if length, names and values of properties are identical
  compare([[1, [2, 3]], [[1, [2, 3]]); // true
  compare([[1, [2, 3], 4], [[1, [2, 3]]); // false
  compare({a: 2, b: 3}, {a: 2, b: 3}); // true
  compare({a: 2, b: 3}, {b: 3, a: 2}); // true
  compare({a: 2, b: 3, c: 4}, {a: 2, b: 3}); // false
  compare({a: 2, b: 3}, {a: 2, b: 3, c: 4}); // false
  compare([[1, [2, {a: 4}], 4], [[1, [2, {a: 4}]]); // true
*/ function $d73968d8a0a066f2$var$compare(value1, value2) {
    if (value1 === value2) return true;
    /* eslint-disable no-self-compare */ // if both values are NaNs return true
    if (value1 !== value1 && value2 !== value2) return true;
    if (typeof value1 != typeof value2 || // primitive != primitive wrapper
    ({}).toString.call(value1) != ({}).toString.call(value2) // check for other (maybe nullish) objects
    ) return false;
    if (value1 !== Object(value1)) // non equal primitives
    return false;
    if (!value1) return false;
    if (Array.isArray(value1)) return $d73968d8a0a066f2$var$compareArrays(value1, value2);
    if (({}).toString.call(value1) == '[object Set]') return $d73968d8a0a066f2$var$compareArrays(Array.from(value1), Array.from(value2));
    if (({}).toString.call(value1) == '[object Object]') return $d73968d8a0a066f2$var$compareObjects(value1, value2);
    return $d73968d8a0a066f2$var$compareNativeSubtypes(value1, value2);
}
function $d73968d8a0a066f2$var$compareNativeSubtypes(value1, value2) {
    // e.g. Function, RegExp, Date
    return value1.toString() === value2.toString();
}
function $d73968d8a0a066f2$var$compareArrays(value1, value2) {
    var len = value1.length;
    if (len != value2.length) return false;
    for(var i = 0; i < len; i++){
        if (!$d73968d8a0a066f2$var$compare(value1[i], value2[i])) return false;
    }
    return true;
}
function $d73968d8a0a066f2$var$compareObjects(value1, value2) {
    var keys1 = Object.keys(value1);
    var len = keys1.length;
    if (len != Object.keys(value2).length) return false;
    for(var i = 0; i < len; i++){
        var key1 = keys1[i];
        if (!(value2.hasOwnProperty(key1) && $d73968d8a0a066f2$var$compare(value1[key1], value2[key1]))) return false;
    }
    return true;
}


let $3f68aa62fc033904$var$_internalEvent = false;
function $3f68aa62fc033904$export$b27ccd6cf6073c1c() {
    return $3f68aa62fc033904$var$_internalEvent;
}
function $3f68aa62fc033904$export$f0ffca0e7194bd91(el, eventName, options = null) {
    $3f68aa62fc033904$var$_internalEvent = true;
    let event;
    if (window.CustomEvent && typeof window.CustomEvent === 'function') event = new CustomEvent(eventName, {
        detail: options
    });
    else {
        // Compat for IE
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, options);
    }
    el.dispatchEvent(event);
    $3f68aa62fc033904$var$_internalEvent = false;
}


function $b4d1c184cabe171a$export$25cf4bb9cb194205() {
    return false;
}
const $b4d1c184cabe171a$export$d680cb6eec13a7c7 = new Promise((resolve)=>{
    if ($b4d1c184cabe171a$export$25cf4bb9cb194205()) resolve();
    if (document.readyState === "loading") {
        if (document.addEventListener) document.addEventListener('DOMContentLoaded', resolve);
        else document.attachEvent('onreadystatechange', function() {
            if (document.readyState != 'loading') resolve();
        });
    } else resolve();
});
function $b4d1c184cabe171a$export$a5deb02d4df4db34(el, value) {
    for(var i = 0; i < el.options.length; i++)if (el.options[i].value === value) {
        el.selectedIndex = i;
        return true;
    }
    return false;
}
function $b4d1c184cabe171a$export$212ec54c5d687e78(el, attributeName, attributeValue) {
    for(let i = 0; i < el.options.length; i++)if (el.options[i].getAttribute(attributeName) === attributeValue) {
        el.selectedIndex = i;
        return true;
    }
    return false;
}



var $fw0Zn = parcelRequire("fw0Zn");
function $e41b329f42db23c8$export$aafcad1af8162002(el) {
    const raw = el.getAttribute('data-options');
    try {
        return JSON.parse(raw);
    } catch (e) {
        return {};
    }
}
async function $e41b329f42db23c8$export$bb8a045c548d38f9(className, errorMessage, callback) {
    const elements = document.getElementsByClassName(className);
    if (!elements.length) return;
    const record = await (0, $fw0Zn.get_info)();
    if (record.error()) {
        console.error('Geolocation IP Detection Error (' + errorMessage + '): ' + record.error());
        return;
    }
    Array.from(elements).forEach((el)=>callback(el, record));
}
function $e41b329f42db23c8$export$2bcc52ba6c088b4a(el, record, property = null) {
    const opt = $e41b329f42db23c8$export$aafcad1af8162002(el);
    property = property || opt.property;
    if (opt.skip_cache) console.warn("Geolocation IP Detection: The property 'skip_cache' is ignored in AJAX mode. You could disable the response caching on the server by setting the constant GEOIP_DETECT_READER_CACHE_TIME.");
    return record.get_with_locales(property, opt.lang, opt.default);
}





let $7944654ce2dd9d65$var$_listener_active = false; // for recursion detection (maybe remove later)
let $7944654ce2dd9d65$var$_change_counter = 0;
function $7944654ce2dd9d65$export$887b871aa5aacaaa() {
    $7944654ce2dd9d65$var$_change_counter++;
    if ($7944654ce2dd9d65$var$_listener_active || $7944654ce2dd9d65$var$_change_counter > 10) {
        console.warn('Error: Thats weird! autosave change detected a recursion (' + $7944654ce2dd9d65$var$_change_counter + ')! Please file a bug report about this and include the first 10 lines of the callstack below:');
        console.trace();
        return false;
    }
    $7944654ce2dd9d65$var$_listener_active = true;
    return true;
}
function $7944654ce2dd9d65$export$f60ab07833116193() {
    $7944654ce2dd9d65$var$_listener_active = false;
}





function $3bb001785c092908$export$2cd8252107eb640b() {
    document.addEventListener('change', $3bb001785c092908$var$event_listener_autosave_on_change, false);
}
function $3bb001785c092908$var$event_listener_autosave_on_change(event) {
    if ((0, $3f68aa62fc033904$export$b27ccd6cf6073c1c)()) return;
    const target = event.target;
    if ((target === null || target === void 0 ? void 0 : target.matches) && target.matches('.js-geoip-detect-input-autosave')) $3bb001785c092908$export$be51a27c79b931de(target);
}
function $3bb001785c092908$export$be51a27c79b931de(el) {
    const property = (0, $e41b329f42db23c8$export$aafcad1af8162002)(el).property;
    const value = el.value;
    if (!(0, $7944654ce2dd9d65$export$887b871aa5aacaaa)()) return;
    if (el.matches('select.js-geoip-detect-country-select')) {
        const selected = el.options[el.selectedIndex];
        const isoCode = selected === null || selected === void 0 ? void 0 : selected.getAttribute('data-c');
        (0, $03d6c28e95082604$export$38a0b31e9febbbe1)('country.iso_code', isoCode.toUpperCase(), {
            reevaluate: false
        });
    }
    (0, $03d6c28e95082604$export$38a0b31e9febbbe1)(property, value, {
        reevaluate: true
    }); // might call do_shortcodes etc.
    (0, $7944654ce2dd9d65$export$f60ab07833116193)();
}


function $ddb23fab3c6f4620$export$c5bfd938fb7f5403(el, record) {
    el.innerText = (0, $e41b329f42db23c8$export$2bcc52ba6c088b4a)(el, record);
}
function $ddb23fab3c6f4620$export$67c46edf2422701b(el, record) {
    const country = record.get_country_iso() || (0, $e41b329f42db23c8$export$aafcad1af8162002)(el).default;
    if (country) el.classList.add('flag-icon-' + country);
}
function $ddb23fab3c6f4620$export$8b2cf4a2576ea856(el, record) {
    let country = record.get_country_iso();
    if ((0, $b4d1c184cabe171a$export$212ec54c5d687e78)(el, 'data-c', country)) {
        (0, $3f68aa62fc033904$export$f0ffca0e7194bd91)(el, 'change');
        return;
    }
    // The country is not the list of countries - select empty option instead
    if ((0, $b4d1c184cabe171a$export$212ec54c5d687e78)(el, 'data-c', '')) (0, $3f68aa62fc033904$export$f0ffca0e7194bd91)(el, 'change');
}
function $ddb23fab3c6f4620$export$46eed00f10e80dd5(el, record) {
    el.value = (0, $e41b329f42db23c8$export$2bcc52ba6c088b4a)(el, record);
    (0, $3f68aa62fc033904$export$f0ffca0e7194bd91)(el, 'change');
}




var $24387ff8da31158e$exports = {};
$24387ff8da31158e$exports = $24387ff8da31158e$var$intersect;
/*
  intersect([1, 2, 5, 6], [2, 3, 5, 6]); // [2, 5, 6]
  intersect([1, 2, 2, 4, 5], [3, 2, 2, 5, 7]); // [2, 5]
*/ function $24387ff8da31158e$var$intersect(arr1, arr2) {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) throw new Error('expected both arguments to be arrays');
    var result = [];
    var set = $24387ff8da31158e$var$convertArrayToSet(arr2);
    var memo = {};
    for(var i = 0; i < arr1.length; i++){
        var item = arr1[i];
        if (set.hasOwnProperty(item) && !memo.hasOwnProperty(item)) {
            result.push(item);
            memo[item] = true;
        }
    }
    return result;
}
function $24387ff8da31158e$var$convertArrayToSet(arr) {
    var output = {};
    for(var i = 0; i < arr.length; i++){
        var item = arr[i];
        if (!output.hasOwnProperty(item)) output[item] = true;
    }
    return output;
}


function $34cfab0a14aff422$export$7f72d39cfa7a0f7a(el, record) {
    const opt = (0, $e41b329f42db23c8$export$aafcad1af8162002)(el);
    const evaluated = $34cfab0a14aff422$export$626a13a1fe51c67a(opt.parsed, opt, record);
    if (!evaluated) {
        el.style.display = "none";
        el.classList.add('geoip-hidden');
        el.classList.remove('geoip-shown');
    } else {
        el.style.display = '';
        el.classList.remove('geoip-hidden');
        el.classList.add('geoip-shown');
    }
}
function $34cfab0a14aff422$export$626a13a1fe51c67a(parsed, opt, record) {
    const alternativePropertyNames = [
        'name',
        'iso_code',
        'iso_code3',
        'code',
        'geoname_id'
    ];
    let isConditionMatching = parsed.op === 'or' ? false : true;
    parsed.conditions.forEach((c)=>{
        let subConditionMatching = false;
        let values = [];
        const raw_value = record.get_raw(c.p);
        if (raw_value === null) subConditionMatching = false;
        else if (typeof raw_value === 'object') alternativePropertyNames.forEach((name)=>{
            if (raw_value[name]) values.push(raw_value[name]);
            else if (name == 'name') values.push(record.get_with_locales(c.p, opt.lang));
        });
        else values = [
            raw_value
        ];
        subConditionMatching = $34cfab0a14aff422$var$geoip_detect2_shortcode_check_subcondition(c.v, values);
        if (c.not) subConditionMatching = !subConditionMatching;
        if (parsed.op === 'or') isConditionMatching = isConditionMatching || subConditionMatching;
        else isConditionMatching = isConditionMatching && subConditionMatching;
    });
    if (parsed.not) isConditionMatching = !isConditionMatching;
    return isConditionMatching;
}
function $34cfab0a14aff422$var$geoip_detect2_shortcode_check_subcondition(expectedValues, actualValues) {
    if (actualValues[0] === true) actualValues = [
        'true',
        'yes',
        'y',
        '1'
    ];
    else if (actualValues[0] === false) actualValues = [
        'false',
        'no',
        'n',
        '0',
        ''
    ];
    actualValues = actualValues.map((x)=>String(x).toLowerCase());
    expectedValues = expectedValues.split(',');
    if (expectedValues.indexOf('') !== -1) {
        if (actualValues.length === 0) return true;
    }
    const intersect = (0, (/*@__PURE__*/$parcel$interopDefault($24387ff8da31158e$exports)))(expectedValues, actualValues);
    return intersect.length > 0;
}


const $9cee2e12fa11ef69$export$7481777ea0ea965d = function() {
    (0, $3bb001785c092908$export$2cd8252107eb640b)();
};
const $9cee2e12fa11ef69$export$42610705290faf95 = async function do_shortcodes() {
    // Before doing any of these, the DOM tree needs to be loaded
    await (0, $b4d1c184cabe171a$export$d680cb6eec13a7c7);
    // These are called in parallel, as they are async functions - wait for all to finish
    Promise.allSettled([
        (0, $e41b329f42db23c8$export$bb8a045c548d38f9)('js-geoip-detect-shortcode', 'could not execute shortcode(s) [geoip_detect2 ...]', (0, $ddb23fab3c6f4620$export$c5bfd938fb7f5403)),
        (0, $e41b329f42db23c8$export$bb8a045c548d38f9)('js-geoip-detect-flag', 'could not configure the flag(s)', (0, $ddb23fab3c6f4620$export$67c46edf2422701b)),
        (0, $e41b329f42db23c8$export$bb8a045c548d38f9)('js-geoip-text-input', 'could not set the value of the text input field(s)', (0, $ddb23fab3c6f4620$export$46eed00f10e80dd5)),
        (0, $e41b329f42db23c8$export$bb8a045c548d38f9)('js-geoip-detect-country-select', 'could not set the value of the select field(s)', (0, $ddb23fab3c6f4620$export$8b2cf4a2576ea856)),
        (0, $e41b329f42db23c8$export$bb8a045c548d38f9)('js-geoip-detect-show-if', 'could not execute the show-if/hide-if conditions', (0, $34cfab0a14aff422$export$7f72d39cfa7a0f7a))
    ]);
    const body = document.getElementsByTagName('body')[0];
    (0, $3f68aa62fc033904$export$f0ffca0e7194bd91)(body, 'geoip-detect-shortcodes-done');
};





var $fw0Zn = parcelRequire("fw0Zn");
function $73929a6ea3471960$export$fd37e2b9d7d82468(record) {
    return {
        country: record.get('country.iso_code'),
        'country-is-in-european-union': record.get('country.is_in_european_union', false),
        continent: record.get('continent.code'),
        province: record.get('most_specific_subdivision.iso_code'),
        city: record.get('city.names.en')
    };
}
function $73929a6ea3471960$var$remove_css_classes_by_prefix(el, prefix) {
    const classes = el.className.split(" ").filter((c)=>!c.startsWith(prefix));
    el.className = classes.join(" ").trim();
}
async function $73929a6ea3471960$export$69cfbde487906451() {
    const record = await (0, $fw0Zn.get_info)();
    if (record.error()) {
        console.error('Geolocation IP Detection Error (could not add CSS-classes to body): ' + record.error());
        return;
    }
    await (0, $b4d1c184cabe171a$export$d680cb6eec13a7c7);
    $73929a6ea3471960$export$4e7274a5cb77ccb6(record);
}
// ported from Wordpress PHP
function $73929a6ea3471960$var$sanitize_html_class(string) {
    string = string + '';
    string = string.replace(/%[a-fA-F0-9][a-fA-F0-9]/g, '');
    string = string.replace(/[^A-Za-z0-9_-]/g, '');
    return string;
}
function $73929a6ea3471960$export$4e7274a5cb77ccb6(record) {
    const css_classes = $73929a6ea3471960$export$fd37e2b9d7d82468(record);
    const body = document.getElementsByTagName('body')[0];
    // Remove old classes in case there are any
    $73929a6ea3471960$var$remove_css_classes_by_prefix(body, 'geoip-');
    for (let key of Object.keys(css_classes)){
        const value = $73929a6ea3471960$var$sanitize_html_class(css_classes[key]);
        if (value) {
            if (typeof value == 'string') body.classList.add(`geoip-${key}-${value}`);
            else body.classList.add(`geoip-${key}`);
        }
    }
    (0, $3f68aa62fc033904$export$f0ffca0e7194bd91)(body, 'geoip-detect-body-classes-done');
}



var $5eYZm = parcelRequire("5eYZm");

var $kXwF1 = parcelRequire("kXwF1");
let $b016e4ccc3c135fb$var$firstCall = true;
function $b016e4ccc3c135fb$export$f22da7240b7add18() {
    if ($b016e4ccc3c135fb$var$firstCall) {
        (0, $9cee2e12fa11ef69$export$7481777ea0ea965d)();
        $b016e4ccc3c135fb$var$firstCall = false;
    }
    if ((0, $5eYZm.options).do_body_classes) (0, $73929a6ea3471960$export$69cfbde487906451)();
    // Do all the shortcodes that are in the HTML. Even if shortcodes is not enabled globally, they might be enabled for a specific shortcode.
    (0, $9cee2e12fa11ef69$export$42610705290faf95)();
    (0, $kXwF1.setRecordDataLastEvaluated)();
}



var $kXwF1 = parcelRequire("kXwF1");
function $03d6c28e95082604$var$processOptions(options) {
    options = options || {};
    if (typeof options == 'number') options = {
        'duration_in_days': options
    };
    options.duration_in_days = options.duration_in_days || (0, $5eYZm.options).cookie_duration_in_days;
    if (options.duration_in_days < 0) {
        console.warn('Geolocation IP Detection set_override_data() did nothing: A negative duration doesn\'t make sense. If you want to remove the override, use remove_override() instead.');
        return false;
    }
    if (typeof options.reevaluate == 'undefined') options.reevaluate = true;
    return options;
}
function $03d6c28e95082604$var$changeRecord(record, property, value) {
    record = record || {};
    property = property || '';
    property = (0, $e96f1.camelToUnderscore)(property);
    const oldData = (0, (/*@__PURE__*/$parcel$interopDefault($aUbCw)))(record, property);
    if (typeof oldData == 'object' && typeof oldData.names == 'object') property += '.name';
    if (property.endsWith('.name')) {
        property += 's'; // e.g. country.name -> country.names
        value = {
            'en': value
        };
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($8435f80da3db6af7$exports)))(record, property, value);
    return record;
}
function $03d6c28e95082604$export$38a0b31e9febbbe1(property, value, options) {
    let record = (0, $kXwF1.getRecordDataFromLocalStorage)();
    record = $03d6c28e95082604$var$changeRecord(record, property, value);
    $03d6c28e95082604$export$c3c74383dfd15775(record, options);
}
function $03d6c28e95082604$export$c3c74383dfd15775(record, options) {
    options = $03d6c28e95082604$var$processOptions(options);
    if (record && typeof record.serialize === 'function') record = record.serialize();
    return $03d6c28e95082604$var$set_override_data(record, options);
}
function $03d6c28e95082604$var$set_override_data(newData, options) {
    newData = newData || {};
    (0, (/*@__PURE__*/$parcel$interopDefault($8435f80da3db6af7$exports)))(newData, 'extra.override', true);
    (0, $de3ze.setLocalStorage)((0, $5eYZm.options).cookie_name, newData, options.duration_in_days * 86400);
    if (options.reevaluate && !(0, $d73968d8a0a066f2$export$2e2bcd8739ae039)(newData, (0, $kXwF1.getRecordDataLastEvaluated)())) {
        (0, $b016e4ccc3c135fb$export$f22da7240b7add18)();
        return true;
    }
    return false;
}
function $03d6c28e95082604$export$cacb6011bc19db0b(options) {
    options = $03d6c28e95082604$var$processOptions(options);
    (0, $de3ze.setLocalStorage)((0, $5eYZm.options).cookie_name, {}, -1);
    if (options.reevaluate) (0, $b016e4ccc3c135fb$export$f22da7240b7add18)();
    return true;
}



// Evaluate shortcodes, body classes, etc.
(0, $b016e4ccc3c135fb$export$f22da7240b7add18)();
// Extend window object 
window.geoip_detect.get_info = (0, $fw0Zn.get_info);
window.geoip_detect.set_override = (0, $03d6c28e95082604$export$c3c74383dfd15775);
window.geoip_detect.set_override_with_merge = (0, $03d6c28e95082604$export$38a0b31e9febbbe1);
window.geoip_detect.remove_override = (0, $03d6c28e95082604$export$cacb6011bc19db0b);

})();
//# sourceMappingURL=frontend_full.js.map
